import React from 'react';
import {useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {StyledAvatar, StyledBubbleContainer, StyledContainer} from './styles';
import {BubbleContainerProps} from './types';

function BubbleContainer({isClient, children}: BubbleContainerProps) {
	const {colors} = useTheme();
	const {isMobile} = useMediaQueries();
	const {
		dataHostNameState: {productIcon},
	} = useHostName();
	return (
		<StyledContainer $isClient={isClient}>
			<StyledAvatar>
				{isClient ? (
					<Icon name="person-filled" color={colors.light.info['160Percent']} />
				) : (
					productIcon({size: 30})
				)}
			</StyledAvatar>
			<StyledBubbleContainer $isClient={isClient} $isMobile={isMobile}>
				{children}
			</StyledBubbleContainer>
		</StyledContainer>
	);
}

export {BubbleContainer};
